import { useEffect } from 'react';
import { format } from 'date-fns';
import { phonePrefixesByCountry } from '../../constant/phone';

export const addNoScroll = (element) => {
  element.css({
    overflow: 'hidden'
  });
};

export const removeNoScroll = (element) => {
  element.css({
    overflow: 'visible'
  });
};

export const isInViewport = (elemId, percent) => {
  const element = document.getElementById(elemId);
  const elemData = element.getBoundingClientRect();
  const percentage = (percent * elemData.height) / 100;
  return (
    elemData.top >= 0 - elemData.height + percentage &&
    elemData.left >= 0 &&
    elemData.bottom <= (window.innerHeight || document.documentElement.clientHeight) + elemData.height - percentage &&
    elemData.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const isColliding = (elemRef, elemToHide) => {
  const reference = document.getElementById(elemRef);

  const refElement = reference.getBoundingClientRect();
  const toHideElement = elemToHide.getBoundingClientRect();

  const notColliding = toHideElement.bottom < refElement.top || toHideElement.top > refElement.bottom;

  return !notColliding;
};

// export const scrollTo(element, marginTop) {
// 	$('html, body').animate({
// 		scrollTop: element.offset().top - marginTop
// 	}, 200);
// }

export const phoneSeparator = (phones) => {
  let phonesArray = [];
  const phonesSeparator = '/';
  if (phones.indexOf(phonesSeparator) !== -1) {
    phones.split(phonesSeparator).forEach((value) => {
      if (value) {
        phonesArray.push(value.trim());
      }
    });
  } else {
    phonesArray = [phones];
  }
  return phonesArray;
};

export const inputOnlyNumbers = (e) => {
  const pattern = /[A-Za-záéíóúÁÉÍÚÓñÑ_~=_<>¡!¿'?.,:;@#$/%°¬|^"¨`´&}{#*\\]/;
  const finalVal = e.target.value.replace(pattern, '');
  return finalVal;
};

export const onPasteOnlyNumbers = (e) => {
  const paste = e.clipboardData.getData('Text');
  const newStr = paste.replace(/[A-Za-záéíóúÁÉÍÚÓñÑ_~=_<>¡!¿'?.,:;@#$/%°¬|^"¨`´&}{#*\\]/g, '');
  if (paste !== newStr) {
    e.preventDefault();
  }
};

export const getDate = () => {
  const dtToday = new Date();
  const month = this.toTwoDigits(dtToday.getMonth() + 1);
  const day = this.toTwoDigits(dtToday.getDate());
  const year = dtToday.getFullYear();
  return `${year}-${month}-${day}`;
};

export const toTwoDigits = (value) => {
  if (value < 10) {
    return `0${value.toString()}`;
  }
  return value;
};

export const mailValidator = (mail) => {
  const emailReg = /^[a-z0-9_+-]+(\.[a-z0-9_+-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*\.([a-z]{2,6})$/i;
  return emailReg.test(mail);
};

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const isBrasil = (id) => {
  return id === 'IW' || id === 'WI' || id === 'IC';
};

export const isDevelopment = (avisoInfo) => {
  return avisoInfo.postingType === 'DEVELOPMENT' || avisoInfo.postingType === 'UNIT';
};

export const htmlDecode = (input, removeHtml) => {
  const doc = new DOMParser().parseFromString(input, 'text/html');
  const text = doc.documentElement.textContent;
  return removeHtml ? text.replace(/<\/?[^>]+(>|$)/g, '') : text;
};

// export const decodeCookie(cookieKey) {
// 	return typeof $.cookie(cookieKey) !== 'undefined' ? decodeURIComponent($.cookie(cookieKey)) : ''
// }

export const encodeCookie = (cookieValue) => {
  return typeof cookieValue !== 'undefined' ? encodeURIComponent(cookieValue) : '';
};

export const setExpireHours = (hours) => {
  const now = new Date();
  let time = now.getTime();
  time += 3600 * hours;
  now.setTime(time);
  now.toUTCString();
  return now;
};

export const numberFormat = (number, siteId) => {
  if (number) {
    const siteIds = ['COA', 'ADV', 'URB', '24MX'];
    const localeString = siteIds.includes(siteId) ? 'en' : 'es';
    const formatedNumber = number.toLocaleString(localeString);
    return isNaN(formatedNumber.replace(/[,.]/g, '')) ? '' : formatedNumber;
  }
};

export const getDeviceBreakpoint = () => {
  // Detecta sistema operativo
  let jsDeviceDetected = 'pc';
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    jsDeviceDetected = 'mobileDevice';
  }

  // Detecta MediaQueries
  const cssBodySelector = window.getComputedStyle(document.querySelector('body'), ':before');
  const cssDeviceDetected = cssBodySelector.getPropertyValue('content').replace(/"/g, '');

  return {
    breakpoint: cssDeviceDetected,
    device: jsDeviceDetected,
    key: `${cssDeviceDetected}/${jsDeviceDetected}`
  };
};

export const queryParams = (obj) =>
  Object.keys(obj)
    .map((key) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`;
    })
    .join('&');

export const lazyImages = (imgSelector) => {
  /* imgSelectorClass = .lazyImg */
  if (typeof IntersectionObserver !== 'undefined') {
    // Si existe la API de IntersectionObserver en el navegador
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          entry.target.src = entry.target.dataset.src;
          observer.unobserve(entry.target);
        }
      });
    };
    const observer = new IntersectionObserver(callback, {
      root: null,
      rootMargin: '10px 0px',
      threshold: 0.1
    });
    document.querySelectorAll(imgSelector).forEach((img) => observer.observe(img));
  } else {
    // Si no existe la API hacemos que se activen las imagenes igual
    const images = document.querySelectorAll(imgSelector);
    images.forEach((img) => {
      img.target.src = img.target.dataset.src;
    });
  }
};

export const useOutsideClick = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
};

export const dateFormatter = (date, formatRequired) => {
  return format(new Date(date), formatRequired);
};

// export const phoneCountryCodeString = () => {
//   const data = {

//   }
// }

export const phoneCountryCodes = (countryCode) => {
  const data = phonePrefixesByCountry;

  let countryPhoneData = data[countryCode];
  if (!countryPhoneData) {
    // eslint-disable-next-line prefer-destructuring
    countryPhoneData = data[1]; // arg
  }
  return countryPhoneData.code;
};

export const preferredPhoneCountries = ['ar', 'pe', 'pa', 'mx', 'ec', 'cl'];

export const customCountriesLabel = { pe: 'Peru (Perú)', pa: 'Panama (Panamá)', mx: 'Mexico (México)' };

/**
 * busca en un objecto o array por nombre
 * @param {object|| array} object
 * @param {string} name
 * @returns object
 */
export const deepMap = (object, name) => {
  if (Array.isArray(object)) {
    let data = null;
    // eslint-disable-next-line no-restricted-syntax
    for (const val of object) {
      if (typeof val === 'object' && val[name]) {
        data = val;
        break;
      } else {
        deepMap(val, name);
      }
    }
    return data;
  }
  if (typeof object === 'object' && object[name]) {
    return object;
  }
  return null;
};
